export const useUIStore = defineStore('ui', {
  state: () => {
    return {
      burgerMenu: false,

      accessibility: {
        fullscreen: false,
        biggerText: 0,
        highContrast: false,
      },

      liveUpdate: {
        currentBundleId: null,
        nativeVersion: '',
      },
    };
  },

  actions: {
    accessibilityUpdate(payload) {
      this.accessibility = {
        ...this.accessibility,
        ...payload,
      };

      window.localStorage.setItem('ui-accessibility', JSON.stringify(this.accessibility));
    },

    chromeExtensionSendMessage(detail) {
      if (document.body.getAttribute('data-chrome-extension')) {
        window.dispatchEvent(new CustomEvent('chromeExtensionSendMessage', {
          detail,
        }));

        if (!detail?.stopAudio) { // do not log stopAudio messages
          console.log('[AUDIO] Extension', detail);
        }

        return true;
      }

      if (!detail?.stopAudio) { // do not log stopAudio messages
        console.log('[AUDIO] Browser', detail);
      }

      return false;
    },
  },

  getters: {
  },
});
